<div class="d-flex flex-column influencer-basic-information text-left" *ngIf="influencer != null">
  <div class="flex-g1"
       [ngClass]="{'clickable': allowRedirectToInfluencerPage}"
       (click)="openInfluencerDetails()">
    <achoo-user-avatar
      [showCountryFlagIcon]="showCountryFlagIcon"
      [userAvatarPicture]="influencer.profilePicture"
      [userCountryCode]="getCountryCode(influencer)"
      [avatarHeight]="10.15"
      [avatarWidth]="10.15"
      [countryHeight]="3.15"
      [countryWidth]="3.15"
      [showIgLoader]="supportIgStoryLoader"
      [influencerId]="influencer.id"
      (afterImageLoaded)="onLoadedAvatarUser()"
      [isTopCountryFlag]="true"
    ></achoo-user-avatar>
  </div>

  <div class="fix-mobile">
    <div class="flex-g1 influencer-name"
         [ngClass]="{'clickable': allowRedirectToInfluencerPage}"
         (click)="openInfluencerDetails()">
      <div class="influencer-name">
        {{influencer.name}}
      </div>
    </div>
    <div class="flex-g1 channel-info"
         *ngIf="enableForMediaPlatform"
         [ngClass]="{'clickable': allowRedirectToInfluencerPage}"
         (click)="openInfluencerDetails()">
      <div class="d-flex flex-lg-row flex-md-row">
        <div class="channel-info-item influencer-country ellipsis">
          <span title="{{countryName}}">{{countryName}}</span>
        </div>
        <div>
          |
        </div>
        <div class="channel-info-item influencer-total-posts" *ngIf="numberOfPost">
          <span>{{numberOfPost | thousandNumberSuffix}}</span>
          <span> {{'discover.influencer.posts' | translate}}</span>
        </div>
        <div>
          |
        </div>
        <div class="channel-info-item influencer-total-followers" *ngIf="numberOfFollower">
          <span>{{numberOfFollower | thousandNumberSuffix}}</span>
          <span> {{'discover.influencer.followers' | translate}}</span>
        </div>
      </div>
    </div>
    <div class="d-flex flex-g1 description"
         *ngIf="enableForMediaPlatform"
         [ngClass]="{'clickable': allowRedirectToInfluencerPage}"
         (click)="openInfluencerDetails()">
      <span *ngIf="influencer.description">{{influencer.description}}</span>
      <span *ngIf="!influencer.description" class="text-italic">{{'INFLUENCER.no_description' | translate}}</span>
    </div>
    <div class="d-flex flex-g1 platforms mobile" *ngIf="onMobile">
      <span class="platform-icon" *ngFor="let id of platformList">
        <img [src]="getPlatformIcon(id)" [ngClass]="{'disabled-icon': !hasPlatform(id)}">
      </span>
    </div>
    <div class="d-flex flex-g1 platforms" *ngIf="!onMobile">
      <span class="platform-icon" [class.influencer-app]="isInInfluencerApp" [class.advertiser-app]="!isInInfluencerApp"
        *ngFor="let id of platformList">
        <ng-container *ngIf="!isInInfluencerApp">
          <div *ngIf="hasPlatform(id)" data-type="channel-indicator" (clickOutside)="onClickOutsideTooltip($event.target)">
            <img [src]="getPlatformIcon(id)" placement="top" 
              [ngbTooltip]="channelIndicator" triggers="manual" #tooltip="ngbTooltip" 
              (click)="toggleChannelIndicator(tooltip, id)"
              (mouseenter)="onTooltipMouseEnter(tooltip, id)" (mouseout)="onTooltipMouseOut(tooltip)">
          </div>
          <img *ngIf="!hasPlatform(id)" [src]="getPlatformIcon(id)" class="disabled-icon">
        </ng-container>
        <ng-container *ngIf="isInInfluencerApp">
          <img [src]="getPlatformIcon(id)" [ngClass]="{'disabled-icon': !hasPlatform(id)}" placement="top" 
            ngbTooltip="{{getHandle(id)}}">
        </ng-container>
      </span>
    </div>
    <div class="d-flex flex-g1 justify-content-center align-items-center content-shadow-box performance-global-kpis" *ngIf="globalKpi && enableForMediaPlatform">
      <div class="d-flex flex-lg-row flex-auto flex-md-row">
        <div class="d-flex reach">
          <div class="d-flex flex-column flex-auto">
            <label class="kpi-label">{{'common.reach' | translate}}</label>
            <h3 class="kpi-value" placement="bottom"
                ngbTooltip="{{'info_box.influencer.reach' | translate}}"
                *ngIf="globalKpi.reach">
              {{ globalKpi.reach.value | thousandNumberSuffix }}
            </h3>
          </div>
        </div>
        <div class="d-flex impact">
          <div class="d-flex flex-column flex-auto">
            <label class="kpi-label">{{'common.impact' | translate}}</label>
            <h3 class="kpi-value" placement="bottom"
                ngbTooltip="{{'info_box.influencer.impact' | translate}}"
                *ngIf="globalKpi.impact">
              {{ globalKpi.impact.value | percentNumberSuffix }}
            </h3>
          </div>
        </div>
        <div class="d-flex engagement">
          <div class="d-flex flex-column flex-auto">
            <label class="kpi-label">{{'common.engagement' | translate}}</label>
            <h3 class="kpi-value" placement="bottom"
                ngbTooltip="{{'info_box.influencer.engagement' | translate}}"
                *ngIf="globalKpi.engagement">
              {{ globalKpi.engagement.value | thousandNumberSuffix }}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #channelIndicator>
  <div class="channel-indicator-container">
    <div class="channel-indicator" *ngFor="let channel of tooltipChannels">
      <div class="channel-title-row">
        <div class="channel-title">{{channel.handle}}</div>
        <a class="channel-link" target="_blank" [attr.href]="channel.link">
          <img src="assets/images/channel-indicator/link.svg" alt="Channel link">
        </a>
      </div>
      <div class="channel-status">
        <div class="channel-status-icon">
          <img *ngIf="!channel.status || channel.status === 'active' || channel.status === 'authorized'" 
            src="assets/images/channel-indicator/status-active.svg" alt="Channel status">
          <img *ngIf="channel.status === 'deleted' || channel.status === 'not_found'" 
            src="assets/images/channel-indicator/status-deleted.svg" alt="Channel status">
          <img *ngIf="channel.status === 'private'" 
            src="assets/images/channel-indicator/status-private.svg" alt="Channel status">
        </div>
        <div class="channel-status-title"
          [class.active]="!channel.status || channel.status === 'active' || channel.status === 'authorized'"
          [class.deleted]="channel.status === 'deleted' || channel.status === 'not_found'"
          [class.private]="channel.status === 'private'">
          <ng-container *ngIf="!channel.status || channel.status === 'active'">{{'info_box.influencer.channel_status.active' | translate}}</ng-container>
          <ng-container *ngIf="channel.status === 'authorized'">{{'info_box.influencer.channel_status.authorized' | translate}}</ng-container>
          <ng-container *ngIf="channel.status === 'deleted'">{{'info_box.influencer.channel_status.deleted' | translate}}</ng-container>
          <ng-container *ngIf="channel.status === 'not_found'">{{'info_box.influencer.channel_status.not_found' | translate}}</ng-container>
          <ng-container *ngIf="channel.status === 'private'">{{'info_box.influencer.channel_status.private' | translate}}</ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>






// WEBPACK FOOTER //
// ./src/app/main/influencer-basic-information/influencer-basic-information.component.html